<template>
	<v-container>
		<div class="site-not-available-wrapper">
			<div class="site-not-available-header">
				<img :src="`${staticPath}images/modalTopLogo.png`" class="image-position"/>
			</div>
			<div class="site-not-available-body">
				<v-img :src="backImage" class="background-image">
				<div class="site-not-available-text-wrapper">
					<div class="site-not-available-text-title">
						<template v-if="$te('shopComponents.gtDemo.tenants.siteNotAvailableTid100.siteNotAvailableTitle')">
							{{$t("shopComponents.gtDemo.tenants.siteNotAvailableTid100.siteNotAvailableTitle")}}
						</template>
						<template v-else>
							<template v-if="$store.state.localization.persistedData.lastLocaleUsedAdmin === 'en'">
								Temporary out of service
							</template>
							<template v-else>
								Midlertidigt ude af drift
							</template>
						</template>
					</div>
					<div class="site-not-available-text-sub">
						<template v-if="isKioskChannel && $te('shopComponents.gtDemo.tenants.siteNotAvailableTid100.siteNotAvailableSubtitleKiosk')">
							{{$t("shopComponents.gtDemo.tenants.siteNotAvailableTid100.siteNotAvailableSubtitleKiosk")}}
						</template>
						<template v-else-if="isKioskChannel">
							<template v-if="$store.state.localization.persistedData.lastLocaleUsedAdmin === 'en'">
								Please contact our employee to order your sunset meal
							</template>
							<template v-else>
								Venligst gå til kassen for at bestille
							</template>
						</template>
						<template v-if="!isKioskChannel && $te('shopComponents.gtDemo.tenants.siteNotAvailableTid100.siteNotAvailableSubtitle')">
							{{$t("shopComponents.gtDemo.tenants.siteNotAvailableTid100.siteNotAvailableSubtitle")}}
						</template>
						<template v-else-if="!isKioskChannel">
							<template v-if="$store.state.localization.persistedData.lastLocaleUsedAdmin === 'en'">
								Please go to your nearest Sunset Boulevard to order you sunset meal
							</template>
							<template>
								Venligst foretag din bestilling i din nærmeste Sunset restaurant
							</template>
						</template>
					</div>
				</div>
				</v-img>
				<div v-if="!isKioskChannel" class="site-not-available-footer">
					<v-btn flat @click="redirectLink">{{$t("shopComponents.gt2.tenants.siteNotAvailableTid100.redirection")}}</v-btn>
				</div>
			</div>
		</div>
	</v-container>
</template>

<script>
	import * as Utils from "../../../../libraries/utils";
	import {mapGetters} from "vuex";
	import appConfig, {channelEnum} from "../../../../appconfig";
	import KioskLandingPageMixin from "../../../../mixins/KioskLandingPage.mixin.js";

	const unavailableTextByChannel = {
		kiosk: { conditionField: "isTenantUnavailableKiosk", textField: "tenantUnavailableCustomTextKiosk" },
		desktopBrowser: { conditionField: "isTenantUnavailableDesktopBrowser", textField: "tenantUnavailableCustomTextDesktopBrowser" },
		mobileBrowser: { conditionField: "isTenantUnavailableMobileBrowser", textField: "tenantUnavailableCustomTextMobileBrowser" },
		android: { conditionField: "isTenantUnavailableAndroid", textField: "tenantUnavailableCustomTextAndroid" },
		ios: { conditionField: "isTenantUnavailableIos", textField: "tenantUnavailableCustomTextIos" },
		tenant: { conditionField: "isTenantUnavailable", textField: "tenantUnavailableCustomText"}
	};
	export default {
		name: "SiteNotAvailableBM100",
		props: ["siteNotAvailableRedirect"],
		mixins:[KioskLandingPageMixin],
		computed: {
			...mapGetters(["tenantSettings", "globalSelectedShopRefreshToken", "featureToggles"]),
			staticPath() {
				return Utils.getStaticPath();
			},
			
			platform() {
				if (appConfig.mobile.isMobileApp()) {
					const mobileApi = appConfig.mobile.mobileApi();
					return mobileApi.platformId;
				}
				return "";
			},
			customText() {
				const self = this;
				const currentChannel = self.tenantSettings.isTenantUnavailable ? "tenant" : (self.platform || appConfig.channelAlias());
				return  self.tenantSettings[unavailableTextByChannel[currentChannel].conditionField] &&
						self.tenantSettings[unavailableTextByChannel[currentChannel].textField] ||
						self.$t("shopComponents.gt2.tenants.siteNotAvailableTid100.customText");
			},
			backImage() {
				const self = this;
				const imageName = window.innerWidth > 1024 || self.screenRatio > 1 ? "desktop-background" : "tablet-background";
				return Utils.imageLoader(
					"misc",
					`${imageName}.jpg`,
					{page: "LandingPage"},
					"static",
					true
				);
			},
			isKioskChannel() {
				return appConfig.channelAlias() === channelEnum.kiosk;
			},
			redirectLink() {
				const self = this;
				if(self.tenantSettings.sunsetLinks.homePage > 0) {
					return window.open(self.tenantSettings.sunsetLinks.homePage);
				} else {
					return this.siteNotAvailableRedirect;
				}
			}
		},
		async mounted() {
			const self = this;
			// we will perform the version polling if sse is disabled
			if (!self.featureToggles.refreshKioskUsingSse) {
				await self.establishDeployIntervalPolling();
			}
		}
	};
</script>

<style scoped lang="scss">
	.site-not-available-wrapper {
		background-color: #000000 ;
		position: relative;
		.site-not-available-header {
			height: 58px;
			width: 100%;
			background-color: black;
			position: relative;
			img {
				height: 44px;
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
			}
		}
		.site-not-available-body {
			height: calc(100vh - 58px);;
			align-items: flex-end;
			padding: 0;
			background-size: 100% 100%;
			background-position: center;
			.background-image {
				height: calc(100vh - 124px);
				/deep/ .v-image__image {
					opacity: 0.3;
				}
			}
			.site-not-available-text-wrapper {
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
				width: 100%;
				color: #FFFFFF;
				.site-not-available-text-title {
					font-size: 22px;
					text-align: center;
					font-weight: bold;
					line-height: normal;
					font-family: Dispatch;
				}

				.site-not-available-text-sub {
					font-size: 16px;
					text-align: center;
					padding-top: 1.5em;
					font-family: Dispatch;
				}
			}
			.site-not-available-footer {
				position: absolute;
				bottom: 0;
				height: 66px;
				background-color: #000000;
				width: 100%;
				text-align: center;
				padding: 0 0 16px 0;
				z-index: 10000;
				color: white;
				border: 1px solid black;
				.v-btn {
					width: 100%;
					height: 100%;
					margin: 0;
					padding: 0;
					max-width: 500px;
					background-color: #218C74;
					border-radius: 4px;
					border: 1px solid #218C74;
					color: #FFFFFF;
					/deep/ .v-btn__content {
						font-family: Dispatch;
						font-size: 19px;
						font-weight: bold;
					}
				}
			}
		}
	}
	@media screen and (max-width: 1024px) {
		.site-not-available-wrapper {
			.site-not-available-body {
				.site-not-available-text-wrapper {
					top: 25%;
				}
			}
		}
	}
</style>
